/* ── Cart bundle removal helpers (global, used by g_mini_cart + cart.json.liquid) ── */

/**
 * Remove ALL items sharing the same bundle_id (frame + lens).
 * Used by the "Remove" link on the FRAME item.
 */
window.removeCartBundle = function (bundleId) {
  if (!bundleId) return;
  fetch('/cart.js')
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      var updates = {};
      cart.items.forEach(function (item) {
        if (item.properties && item.properties.bundle_id === bundleId) {
          updates[item.key] = 0;
        }
      });
      if (Object.keys(updates).length === 0) return;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
    })
    .then(function () {
      return window.refreshCartFlyout();
    });
};

/**
 * Remove only the lens line item and clear prescription from the frame.
 * Used by the "Remove lens" link on the LENS item.
 */
window.removeCartLens = function (bundleId) {
  if (!bundleId) return;
  fetch('/cart.js')
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      var lensKey = null;
      var frameItem = null;

      cart.items.forEach(function (item) {
        if (!item.properties) return;
        if (item.properties.bundle_id !== bundleId) return;
        if (item.properties.lens_addon === 'true') {
          lensKey = item.key;
        } else {
          frameItem = item;
        }
      });

      var updates = {};

      // Remove the lens line item
      if (lensKey) updates[lensKey] = 0;

      // Re-set the frame item: strip all prescription/lens fields, keep only bundle_id
      if (frameItem) {
        updates[frameItem.key] = {
          quantity: frameItem.quantity,
          properties: { bundle_id: bundleId },
        };
      }

      if (Object.keys(updates).length === 0) return;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
    })
    .then(function () {
      return window.refreshCartFlyout();
    });
};

/** Refresh the cart flyout HTML + badge count after a removal. */
window.refreshCartFlyout = function () {
  fetch('/cart?view=json')
    .then(function (r) {
      return r.text();
    })
    .then(function (html) {
      var el = document.querySelector('.cart-flyout');
      if (el) el.innerHTML = html;
    });
  fetch('/cart.js')
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      var badge = document.querySelector('.la-cart-count');
      if (badge) badge.innerHTML = cart.item_count;
    });
};
